export const ModalPanel = "ModalPanel";
export const ModalPanel__Title = `${ModalPanel}__Title`;
export const ModalPanel__TitleArea = `${ModalPanel}__TitleArea`;
export const ModalPanel__ContentArea = `${ModalPanel}__ContentArea`;
